import React from "react";
import {WarningTargetType, WarningType, WarningUi} from "../../../api/generated";
import {useAppDispatch} from "../../../app/hooks";
import {openPopupModal, PopupModalName} from "../popupModalProvider/popupModalSlice";
import styles from "./WarningBadge.module.css";

interface WarningBadgeProps {
    warnings?: WarningUi[];
}

const WARNING_TYPE_LABELS: Record<WarningType, string> = {
    [WarningType.VehicleProvider]: "Vehicle provider",
    [WarningType.FranchiseFocusStock]: "Franchise focus"
};

const TARGET_TYPE_LABELS: Record<WarningTargetType, string> = {
    [WarningTargetType.Location]: "Location",
    [WarningTargetType.Franchise]: "Franchise"
};

const formatTarget = (warning: WarningUi) => {
    const targetName = warning.targetName || `Unknown ${TARGET_TYPE_LABELS[warning.targetType].toLowerCase()}`;
    const targetId = warning.targetPublicId || "unknown";
    return `${WARNING_TYPE_LABELS[warning.type]} · ${targetName}#${targetId.substring(targetId.length - 4)}`;
};

export const WarningBadge: React.FC<WarningBadgeProps> = ({warnings = []}) => {
    const dispatch = useAppDispatch();

    if (warnings.length === 0) {
        return null;
    }

    const handleOpenWarnings = () => {
        dispatch(openPopupModal({
            name: PopupModalName.CONFIGURATION_ISSUES,
            popupModalProps: {
                title: "Warnings",
                tone: "warning",
                issues: warnings.map(warning => ({
                    message: warning.message,
                    field: formatTarget(warning),
                    updatedAt: warning.updatedAt
                }))
            }
        }));
    };

    return <button
        type="button"
        className={styles.warningBadge}
        onClick={handleOpenWarnings}
    >
        Warnings: {warnings.length}
    </button>;
};
